var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 122.88 122.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill-rule:evenodd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pen") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M118.2.53l4.15,4.15a1.85,1.85,0,0,1,0,2.59l-6.64,6.64L109,7.17,115.61.53a1.84,1.84,0,0,1,2.59,0ZM2.74,119.19l1,1a.65.65,0,0,1,0,.93l-2.14,1.63a.74.74,0,0,1-.94,0l-.45-.45a.71.71,0,0,1,0-.93l1.64-2.14a.63.63,0,0,1,.93,0Zm60.46-73L76.69,59.68C50,85.87,31.4,102.72,5.3,119.9l-2.42-2.43C20.08,90.72,37,72.39,63.2,46.19ZM94.9,5.42,98.08,8.6l-6.87,6.88L90,14.27a2.31,2.31,0,0,0-3.26,0L46.45,54.55a4,4,0,0,1-2-2.8L88.54,5.42a4.47,4.47,0,0,1,6.36,0Zm10.36,2.94,9.26,9.26a3,3,0,0,1,0,4.23L78.79,57.58l-5.51-5.5,32.36-32.37a1.36,1.36,0,0,0,0-1.9l-.57-.57a1.33,1.33,0,0,0-1.9,0L70.81,49.6,65.3,44.1,101,8.36a3,3,0,0,1,4.23,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.d803c8c0df56e4022fbe6503915bf2e3.svg";
export { ForwardRef as ReactComponent };